/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTSVG} from '../../../helpers'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import ReadNotification from '../../../../app/services/table/ReadNotification'
import {mergeTrailingTextForCKEditor} from '../../../../app/services/Functional'

const HeaderNotificationsMenu = ({notifications}: any) => (
  <div
    className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
    data-kt-menu='true'
  >
    <div className='d-flex flex-column bgi-no-repeat rounded-top bg-primary'>
      <h3 className='text-white fw-bold px-9 mt-10 mb-6'>Notifications</h3>
    </div>
    <div className='tab-content'>
      <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
        <div className='scroll-y mh-325px my-5 px-8'>
          {notifications.length > 0 ? (
            notifications.map((notification: any, index: any) => (
              <div key={`alert${index}`} className='d-flex flex-stack py-4'>
                <div className='d-flex align-items-center'>
                  <div className='symbol symbol-35px me-4'>
                    <span className={clsx('symbol-label', `bg-light-primary`)}>
                      {' '}
                      <KTSVG
                        path='/media/icons/duotune/general/gen022.svg'
                        className={`fs-2 text-primary`}
                      />
                    </span>
                  </div>

                  <div className='menu-item mb-0 me-2'>
                    <ReadNotification notification={notification} />
                    <div
                      className={`fs-7 ${notification.is_read ? 'text-gray-400' : 'text-black'}`}
                    >
                      <div
                        className={`preview m-0 ${notification.is_read ? 'text-gray-400' : 'text-black'}`}
                        dangerouslySetInnerHTML={{
                          __html: mergeTrailingTextForCKEditor(notification.description ?? ''),
                        }}
                      />
                    </div>
                  </div>
                </div>
                <span
                  className={`badge badge-light fs-8 ${notification.is_read ? 'text-gray-400' : 'text-black'}`}
                >
                  {notification.created_on}
                </span>
              </div>
            ))
          ) : (
            <div className='d-flex text-center w-100 align-content-center justify-content-center'>
              No matching records found
            </div>
          )}
        </div>

        <div className='menu-item py-3 text-center border-top'>
          <Link
            to={'/notifications'}
            className='btn btn-color-gray-600 btn-active-color-primary menu-link d-block'
          >
            View All
          </Link>
        </div>
      </div>
    </div>
  </div>
)

export {HeaderNotificationsMenu}
